import { State } from './profile.store';
import * as types from '../mutation-types';
import {
  IOption,
  TaskListSourceType,
  TracesSourceType,
  IHeaderSource
} from './profile';

const mutations = {
  [types.SET_SERVICES](state: State, data: any[]) {
    state.headerSource.serviceSource = [...data];
    state.headerSource.currentService = state.headerSource.serviceSource[0];
    state.taskFieldSource.serviceSource = data;
    state.newTaskFields.service = data[0] || {};
  },
  [types.SET_ENDPOINTS](state: State, data: any[]) {
    state.headerSource.endPointService = [
      { key: 'ALL', label: 'All endpoints ' }
    ].concat(data);
    //state.headerSource.currentEndpoint = state.headerSource.endPointService[0];
  },
  // [types.SET_CURRENT_ENDPOINTS](state: State, data: IOption) {
  //
  //  state.headerSource.currentEndpoint=data;
  // },
  [types.SET_TASK_OPTIONS](
    state: State,
    data: { type: string; item: IOption }
  ) {
    const param = ['minThreshold', 'endpointName'];
    state.newTaskFields = {
      ...state.newTaskFields,
      [data.type]: param.includes(data.type) ? data.item.key : data.item
    };
    if (data.type === 'service') {
      state.headerSource.currentService = data.item;
    }
  },
  [types.SET_TASK_LIST](state: State, data: TaskListSourceType[]) {
    state.taskListSource = data;
    const newArr1 = data.map(v => ({ ...v, visible: false }));

    state.taskListSource = newArr1;
  },
  [types.SET_TASK_ID](state: State, data: Number) {
    state.taskId = data;
  },
  [types.SET_TASK_LIST_TOTAL](state: State, data: Number) {
    state.taskListTotal = data;
  },
  toggleTaskItemVisibity(state: State, data: any) {
    state.taskListSource[data].visible = !state.taskListSource[data].visible;
  },
  [types.SET_SEGMENT_SPANS](state: State, data: any[]) {
    state.segmentSpans = data;
  },
  [types.SET_CURRENT_SPAN](state: State, data: any) {
    state.currentSpan = data;
  },
  [types.SET_SEGMENT_LIST](state: State, data: any[]) {
    state.segmentList[data[0]] = data[1];
  },
  [types.SET_CURRENT_SEGMENT](state: State, data: any) {
    state.currentSegment = data;
  },
  [types.SET_PROFILE_ANALYZATION](state: State, data: any[]) {
    state.profileAnalyzation = data;
  },
  [types.SET_HEADER_SOURCE](state: State, data: IHeaderSource) {
    state.headerSource = {
      ...state.headerSource,
      ...data
    };
  },
  [types.SET_HIGHLIGHT_TOP](state: State) {
    state.highlightTop = !state.highlightTop;
  },
  [types.SET_INCLUDE_CHILDREN](state: State, data: boolean) {
    state.includeChildren = data;
  }
};

export default mutations;
